import { useState, useEffect } from 'react';
import { listMyVideos, VideoRecord } from '@/lib/videos';
import { transformVideoRecord } from './transform';
import { SwingLabVideo } from '../types';

export type { SwingLabVideo };

export function useRecentVideos(limit = 10): {
  data: SwingLabVideo[] | undefined;
  isLoading: boolean;
  error?: Error;
} {
  const [data, setData] = useState<SwingLabVideo[] | undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    async function fetchVideos() {
      try {
        setIsLoading(true);
        setError(undefined);
        
        const { data: videos, error: fetchError } = await listMyVideos(limit);
        
        if (fetchError) {
          throw new Error(fetchError.message || 'Failed to fetch videos');
        }
        
        if (videos) {
          setData(videos.map(transformVideoRecord));
        } else {
          setData([]);
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
        setData(undefined);
      } finally {
        setIsLoading(false);
      }
    }

    fetchVideos();
  }, [limit]);

  return { data, isLoading, error };
}